import { render, staticRenderFns } from "./ConsumerDashboardPrepaid_old2.vue?vue&type=template&id=991a2664&scoped=true&"
import script from "./ConsumerDashboardPrepaid_old2.vue?vue&type=script&lang=js&"
export * from "./ConsumerDashboardPrepaid_old2.vue?vue&type=script&lang=js&"
import style0 from "./ConsumerDashboardPrepaid_old2.vue?vue&type=style&index=0&id=991a2664&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "991a2664",
  null
  
)

export default component.exports